import { useSelector } from "react-redux";
import { Store } from "../store";

export default function usePermission(props: { module: string }) {
  const authState = useSelector((state: Store) => state.auth);
  return authState.role?.permissions?.[props.module] || {};
}
